module.exports = __webpack_public_path__ + "6fa811b8c5beca84a8ccd853292c461c.svg"